import axios from 'axios'
import axiosRetry from 'axios-retry'
import store from '@/store'
import router from '@/router'

const api = axios.create({
    baseURL: process.env.VUE_APP_APIV2_URL
})

axiosRetry(api, { retries: 3, retryDelay: axiosRetry.exponentialDelay })

api.interceptors.request.use(function (config) {
    if (config.loader) {
        store.dispatch('loader/load', config.loader)
    }

    if (store.get('auth/token')) {
        config.headers['Authorization'] = 'Bearer ' + store.get('auth/token')
    }

    if (store.get('enrollment/selected')) {
        config.headers['X-Mediko-Period-ID'] = store.get('enrollment/selected@id')
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

api.interceptors.response.use(function (response) {
    if (response.config.loader) {
        store.dispatch('loader/unload', response.config.loader)
    }

    return response;
}, function (error) {
    if (error.config && error.config.loader) {
        store.dispatch('loader/unload', error.config.loader)
    }

    if (error.response && ! error.config.noErrorRedirection) {
        if (error.response.status == 401) {
            store.set('auth/token', null)
            localStorage.removeItem('token')

            router.replace({ name: 'home' })
        } else if (error.response.status == 403) {
            router.replace({ name: 'dashboard' })
        }
    }

    return Promise.reject(error);
});

export default api
